function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.2295 3.96778H19.8087L19.5479 2.17285C19.5457 2.15827 19.5367 2.14722 19.5334 2.13318C19.4899 1.94885 19.3548 1.80976 19.1777 1.76386C19.1202 1.74842 19.0594 1.74555 18.9983 1.75116C18.9925 1.75165 18.9873 1.74933 18.9814 1.75L18.9811 1.75006C18.9809 1.75006 18.9807 1.75 18.9805 1.75C18.9802 1.75006 18.98 1.75019 18.9798 1.75025L17.5535 1.95429L17.166 0.755862C17.1525 0.714175 17.127 0.681277 17.1045 0.645998C17.0923 0.627017 17.0858 0.603823 17.0714 0.586855C17.041 0.551028 17.0023 0.525759 16.9637 0.500063C16.949 0.490175 16.9378 0.475466 16.9221 0.467226C16.8946 0.452944 16.863 0.449343 16.8333 0.44031C16.801 0.430422 16.7706 0.415652 16.7367 0.412478C16.7183 0.41083 16.699 0.417971 16.6802 0.418337C16.6345 0.419314 16.5887 0.418154 16.543 0.43262L16.5369 0.434512C16.5367 0.434573 16.5364 0.434512 16.5361 0.434573C16.5359 0.434634 16.5358 0.434878 16.5355 0.434939L6.47772 3.539L3.48065 3.96778H1.77051C0.793945 3.96778 0 4.80762 0 5.84082V19.9678C0 21 0.793945 21.8398 1.77051 21.8398H22.2295C23.2061 21.8398 24 21 24 19.9678V5.84082C24 4.80762 23.2061 3.96778 22.2295 3.96778ZM18.6293 2.81104L18.7975 3.96778H10.5443L18.6293 2.81104ZM16.3664 1.53321L16.549 2.09802L12.7968 2.63489L16.3664 1.53321ZM22.5 19.9678C22.5 20.166 22.374 20.3398 22.2295 20.3398H1.77051C1.62598 20.3398 1.5 20.166 1.5 19.9678V5.84082C1.5 5.6211 1.64258 5.46778 1.77051 5.46778H22.2295C22.3574 5.46778 22.5 5.6211 22.5 5.84082V19.9678Z",
  fill: "url(#paint0_linear_3_1497)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.8975 13.9229C19.4497 13.9229 19.8975 13.4668 19.8975 12.9043C19.8975 12.3418 19.4497 11.8857 18.8975 11.8857C18.3452 11.8857 17.8975 12.3418 17.8975 12.9043C17.8975 13.4668 18.3452 13.9229 18.8975 13.9229Z",
  fill: "url(#paint1_linear_3_1497)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_3_1497",
  x1: 12,
  y1: 0.412231,
  x2: 12,
  y2: 21.8398,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.354167,
  stopColor: "#00B5EF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.31
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_3_1497",
  x1: 18.8975,
  y1: 11.8857,
  x2: 18.8975,
  y2: 13.9229,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.354167,
  stopColor: "#00B5EF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.31
})));

function SvgPayment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.af888e1e.svg";
export { ForwardRef as ReactComponent };